import { defineMessages } from 'react-intl'

export default defineMessages({
  investigatingOfficerNoOfficer: {
    id: 'app.investingOfficer.noOfficer',
    defaultMessage: 'No Police Officer',
  },
  investigatingOfficerThereWasOfficer: {
    id: 'app.claims.witness.thereWasWitness',
    defaultMessage: 'There Was a Police Officer',
  },
  investigatingOfficerHeadline: {
    id: 'app.investingOfficer.headline',
    defaultMessage: 'Investigating Officer',
  },

  // Validation messages
  validationAddressRequired: {
    id: 'app.investingOfficer.validation.addressRequired',
    defaultMessage: 'Address is required!',
  },
  validationDivisionRequired: {
    id: 'app.investingOfficer.validation.divisionRequired',
    defaultMessage: 'Division is required!',
  },
  validationBadgeRequired: {
    id: 'app.investingOfficer.validation.badgeRequired',
    defaultMessage: 'Badge number is required!',
  },
  validationPhoneRequired: {
    id: 'app.investingOfficer.validation.phoneRequired',
    defaultMessage: 'Phone number is required!',
  },
  validationFirstNameRequired: {
    id: 'app.investingOfficer.validation.firstNameRequired',
    defaultMessage: 'First name is required!',
  },
  validationLastNameRequired: {
    id: 'app.investingOfficer.validation.lastNameRequired',
    defaultMessage: 'Last name is required!',
  },

  // Placeholder messages
  placeholderFirstName: {
    id: 'app.investingOfficer.placeholder.firstName',
    defaultMessage: 'First name',
  },
  placeholderLastName: {
    id: 'app.investingOfficer.placeholder.lastName',
    defaultMessage: 'Last name',
  },
  placeholderPhoneNumber: {
    id: 'app.investingOfficer.placeholder.phoneNumber',
    defaultMessage: 'Phone #',
  },
  placeholderBadge: {
    id: 'app.investingOfficer.placeholder.badge',
    defaultMessage: 'Badge',
  },
  placeholderDivision: {
    id: 'app.investingOfficer.placeholder.division',
    defaultMessage: 'Division',
  },
  placeholderAdress: {
    id: 'app.investingOfficer.placeholder.address',
    defaultMessage: 'Address',
  },
  claimsFillOutTheForm: {
    id: 'app.claims.claimType.form',
    defaultMessage: 'Fill out the form',
  },
})
